import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PremierDestinationEarnDialog } from "@hsbc/portal";
import { Dialog, DialogClose, DialogContent, DialogTrigger } from "@tenant/ui";
import styles from "./styles.module.scss";

export const LearnMoreDialog = ({ children }: PlatformComponentProps) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "PremierDestinationQuickPicks");

  return (
    <Dialog>
      <DialogTrigger className={cn("learnMore")}>{children}</DialogTrigger>
      <DialogContent
        fullScreen
        className={cn("dialog-content")}
        title={t("banners.premierDestination.dialog.title")}
        bottomFixedContent={
          <DialogClose className={cn("close-button")}>
            {t("close.button")}
          </DialogClose>
        }
      >
        <PremierDestinationEarnDialog />
      </DialogContent>
    </Dialog>
  );
};
